import { useState } from 'react';
import { INavigationTip } from '../../types/navigationTips';
import Edit from './components/Edit';
import Show from './components/Show/Show';
import { useControll } from './useControll';

const NavigationTipsScreen = () => {
    const [openFilter, setOpenFilter] = useState(false);
    const [filterType, setFilterType] = useState<string>("");
    const [filterStatus, setFilterStatus] = useState<string>("");
    const [modalType, setModalType] = useState<string>("");
    const [modalStatus, setModalStatus] = useState<string>("");
    const [mode, setMode] = useState<'show' | 'edit'>('show');
    const [editMode, setEditMode] = useState<'create' | 'edit'>('create');
    const [selectedTip, setSelectedTip] = useState<INavigationTip | null>(null);
    const [searchValue, setSearchValue] = useState('');

    const {
        sortBy,
        sortDir,
        navigationTips,
        totalPages,
        totalSize,
        page,
        pageSize,
        setSortBy,
        setSortDir,
        setPage,
        fetchNavigationTips,
        handleDeleteTip,
        handleLoadMore,
        handleResetPage,
        getInfractionTypeCounts,
    } = useControll({ searchValue, filterType, filterStatus });

    const handleSort = (key: string) => {
        const typedKey = key as keyof INavigationTip;
        if (sortBy === typedKey) {
            setSortDir(sortDir === 'asc' ? 'desc' : 'asc');
        } else {
            setSortBy(typedKey);
            setSortDir('asc');
        }
    };

    const handlePageChange = (newPage: number) => {
        if (newPage < 1 || newPage > totalPages) return;
        setPage(newPage);
    };

    const handleSearchChange = (v: string) => {
        setSearchValue(v);
        setPage(1);
    };

    const handleFilterChange = (v: string) => {
        setFilterType(v);
        setPage(1);
    };

    const handleStatusChange = (v: string) => {
        setFilterStatus(v);
        setPage(1);
    };

    const dataCards = [
        { title: 'Total de Dicas', value: totalSize }
    ];

    return mode === 'show' ? (
        <Show
            navigationTips={navigationTips}
            page={page}
            totalPages={totalPages}
            totalSize={totalSize}
            pageSize={pageSize}
            onPageChange={handlePageChange}
            onLoadMore={handleLoadMore}
            onResetPage={handleResetPage}
            sortBy={sortBy}
            sortDir={sortDir}
            onSort={handleSort}
            searchValue={searchValue}
            onSearchChange={handleSearchChange}
            onOpenFilter={() => {
                setModalType(filterType);
                setModalStatus(filterStatus);
                setOpenFilter(true);
            }}
            onStatusChange={handleStatusChange}
            dataCards={dataCards}
            filterType={filterType}
            filterStatus={filterStatus}
            modalType={modalType}
            modalStatus={modalStatus}
            setModalType={setModalType}
            setModalStatus={setModalStatus}
            setFilterStatus={setFilterStatus}
            setOpenFilter={setOpenFilter}
            setFilterType={setFilterType}
            onCreateEdit={() => {
                setEditMode('create');
                setSelectedTip(null);
                setMode('edit');
            }}
            onEditTip={tip => {
                setEditMode('edit');
                setSelectedTip(tip);
                setMode('edit');
            }}
            onDeleteTip={handleDeleteTip}
            onRefresh={fetchNavigationTips}
        />
    ) : (
        <Edit
            mode={editMode}
            tip={selectedTip || undefined}
            onBack={() => {
                fetchNavigationTips();
                setMode('show');
            }}
        />
    );
};

export default NavigationTipsScreen; 